import type { ID } from '@octopus-do/octopus-project-core'
import { createSelector } from '@reduxjs/toolkit'
import type { AppState } from '@store/types'

import type { Comment } from '@/types'

const sorter = (a: Comment, b: Comment) => a.createdAt - b.createdAt

const selectCommentsList = ({ manager: { comments } }: AppState) => comments

export const selectComments =
  (commentable: ID) =>
  ({ manager: { comments } }: AppState) =>
    comments.filter((c) => c.commentable === commentable).sort(sorter)

// Memoised on the comments array: the panel reads this on every store update
// while it is open, and the grouping only changes when a comment does
export const selectCommentsMap = createSelector(
  [selectCommentsList],
  (comments): Record<ID, Comment[]> => {
    const map = comments.reduce(
      (accum, current) => {
        const { commentable } = current
        accum[commentable] = accum[commentable] || []
        accum[commentable].push(current)

        return accum
      },
      {} as Record<ID, Comment[]>
    )

    for (const group of Object.values(map)) {
      group.sort(sorter)
    }

    return map
  }
)
